import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  // List,
  // ListItem,
  // ListItemButton,
  Skeleton,
  Typography,
} from '@mui/material'
import AssignmentIcon from '@mui/icons-material/Assignment'
import TaskIcon from '@mui/icons-material/Task'
import React, { useState } from 'react'
import { ModuleHeader } from '../../components/Module/elements'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'
import BookIcon from '@mui/icons-material/Book'
import { useAuth } from '../../context/AuthContext/AuthContext'
import { useQuery } from 'react-query'
import { useGetUser } from '../../hooks/useGetUser'
import { BaseService } from '../../services/BaseService'
import { moduleType } from '../../constants/modules'
import SkeletonLoading from '../../components/SkeletonLoading'
// import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import ModalLanguage from './ModalLanguage'
import useTranslate from '../../utils/i18n'
import { getLocalStorageData } from '../../utils/storage/storage'

async function getLastHistory(id) {
  const service = new BaseService('/m_history_2')
  const res = await service.getHistory({
    id_user: id,
  })
  if (res.data.status === 'gagal') {
    return {
      data: [],
      total: 0,
    }
  }
  const newData = {
    data: res?.data?.data,
    total: res?.data?.data?.length,
  }
  return newData
}

async function getModules(param) {
  const params = {
    ...param,
  }
  const service = new BaseService('/m_modul_2')
  const res = await service.getModules(params)
  if (res?.status === 'gagal' || res?.data?.status === 'gagal') {
    return 0
  }
  const newData = res?.data?.length
  return newData
}

const UserPage = () => {
  const { t } = useTranslate()
  const { logout } = useAuth()
  const { user } = useGetUser()
  const userLang = getLocalStorageData('userLang')
  const setParams = []

  setParams.push(user.position)

  const params = {
    user: setParams,
    flag_eng: userLang === 'en' ? 1 : 0,
  }

  const { isLoading, data } = useQuery(['user', user.id], async () => getLastHistory(user.id))
  const { isLoading: loadingModules, data: modules } = useQuery(
    ['user-modul', user.id],
    async () => await getModules(params),
  )

  const [openLang, setOpenLang] = useState(false)

  function handleCloseModalLang() {
    setOpenLang(false)
  }

  return (
    <Box height={'100%'} display={'flex'} flexDirection={'column'} justifyContent={'space-between'}>
      <Box display={'flex'} flexDirection={'column'}>
        <Card
          sx={{
            boxShadow: '0px 2px 6px rgba(0,0,0,.2)',
            borderEndEndRadius: '1rem',
            borderEndStartRadius: '1rem',
          }}
        >
          <CardContent>
            <Box display={'flex'} mb={2}>
              <Avatar
                src="w"
                alt={user.fullname}
                sx={{
                  width: '70px',
                  height: '70px',
                }}
              />
              <Box pl={2}>
                <Typography fontWeight={700}>{user.fullname}</Typography>
                <Box mt="10px">
                  <Typography variant="body2">{user.nik}</Typography>
                  <Typography variant="body2">{user.no}</Typography>
                </Box>
              </Box>
            </Box>

            <Divider />
            {!loadingModules ? (
              <Box display={'flex'} justifyContent={'center'} pt={2}>
                <Box
                  width={'100%'}
                  display={'flex'}
                  flexDirection={'column'}
                  justifyContent={'center'}
                  alignItems={'center'}
                >
                  <Typography fontWeight={700}>{t('moduleTotal')}</Typography>
                  <Box display={'flex'} mt={1}>
                    <AssignmentIcon
                      sx={{
                        color: ({ palette }) => palette.warning['light'],
                      }}
                    />
                    <Typography fontWeight={700} ml={2}>
                      {modules}
                    </Typography>
                  </Box>
                </Box>
                <Box
                  width={'100%'}
                  display={'flex'}
                  flexDirection={'column'}
                  justifyContent={'center'}
                  alignItems={'center'}
                >
                  <Typography fontWeight={700}>{t('taskTotal')}</Typography>
                  <Box display={'flex'} mt={1}>
                    <TaskIcon
                      sx={{
                        color: ({ palette }) => palette.success['light'],
                      }}
                    />

                    <Typography fontWeight={700} ml={2}>
                      {data?.total}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            ) : (
              <Box display={'flex'} justifyContent={'space-between'}>
                <Skeleton width={'150px'} height={60} />
                <Skeleton width={'150px'} height={60} />
              </Box>
            )}
          </CardContent>
        </Card>
        <Card
          sx={{
            mt: '30px',
            boxShadow: '0px 2px 6px rgba(0,0,0,.2)',
            borderRadius: '8px',
          }}
        >
          <CardContent>
            <Typography fontWeight={700} mb={2}>
              {t('historyOfModules')}
            </Typography>
            {!isLoading ? (
              <React.Fragment>
                {data.data.length > 0 ? (
                  data.data.map((task, idx) => (
                    <Box
                      key={idx}
                      px={1}
                      py={2}
                      mb={2}
                      sx={{
                        backgroundColor: ({ palette }) =>
                          palette[moduleType[task.tipe_modul]]['light'],
                        borderRadius: '6px',
                        height: '100%',
                      }}
                    >
                      <ModuleHeader
                        sx={{
                          marginBottom: '0px !important',
                        }}
                      >
                        <FiberManualRecordIcon fontSize="small" />
                        {task.nama_modul}
                      </ModuleHeader>
                      <Divider
                        color="white"
                        sx={{
                          my: 1,
                        }}
                      />
                      <Box display={'flex'}>
                        <BookIcon
                          fontSize="small"
                          sx={{
                            color: '#193766',
                          }}
                        />
                        <Typography color={'#193766'}>{task.tipe_modul}</Typography>
                      </Box>
                    </Box>
                  ))
                ) : (
                  <Box display="flex" justifyContent="center" alignItems="center" p={3}>
                    <Typography>{t('noHaveHistory')}</Typography>
                  </Box>
                )}
              </React.Fragment>
            ) : (
              <SkeletonLoading />
            )}
          </CardContent>
        </Card>

        <Card
          sx={{
            mt: '30px',
            boxShadow: '0px 2px 6px rgba(0,0,0,.2)',
            borderRadius: '8px',
          }}
        >
          {/* <CardContent>
            <List>
              <ListItem
                sx={{
                  px: 0,
                }}
              >
                <ListItemButton
                  onClick={() => setOpenLang(true)}
                  sx={{
                    borderBottom: '1px solid #e5e5e5',
                    justifyContent: 'space-between',
                  }}
                >
                  <Typography>{t('selectLang')}</Typography>
                  <KeyboardArrowRightIcon
                    sx={{
                      color: '#898989',
                    }}
                  />
                </ListItemButton>
              </ListItem>
            </List>
          </CardContent> */}
        </Card>
      </Box>
      <Box width={'100%'} pb="10px" mt={'50px'}>
        <Button
          variant="contained"
          fullWidth
          onClick={logout}
          sx={{
            height: '50px',
            color: 'white',
            fontWeight: 700,
          }}
        >
          {t('signOut')}
        </Button>
      </Box>
      <ModalLanguage open={openLang} onClose={handleCloseModalLang} />
    </Box>
  )
}

export default UserPage
